import axios from "axios";
import { authActions, store } from "../store";
import CONFIG from "../config";
import { notify } from "../components/Common/Alerts";
import Utils from "../utils";
import { decryptData } from "../utils/crypto";

const REQUEST_TIMEOUT = 10000; // 10 seconds

const axiosInstance = axios.create({
  baseURL: CONFIG.API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

let isLoggingOut = false;

// ======================
// REQUEST INTERCEPTOR
// ======================
axiosInstance.interceptors.request.use((config) => {
  let auth = store.getState().auth.value;
  const lngData = localStorage.getItem("lng");

  if (auth && typeof auth !== "object") {
    auth = JSON.parse(auth);
  }

  if (auth?.token) {
    config.headers.authorization = auth.token;
    config.headers.lang = lngData;
  }

  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }

  const controller = new AbortController();
  config.signal = controller.signal;

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, REQUEST_TIMEOUT);

  // store metadata
  config.metadata = { timeoutId };

  return config;
});

// ======================
// RESPONSE INTERCEPTOR
// ======================
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config?.metadata?.timeoutId) {
      clearTimeout(response.config.metadata.timeoutId);
    }
    return response;
  },
  (error) => {
    let decryptError = decryptData(error.response.data.data);

    const status = error?.response?.status;
    const config = error.config;

    if (config?.metadata?.timeoutId) {
      clearTimeout(config.metadata.timeoutId);
    }

    if (error.name === "CanceledError") {
      return Promise.reject({
        message: "Request timed out. Please try again.",
        isTimeout: true,
      });
    }

    if (!error.response) {
      return Promise.reject({
        message: "Unable to connect to server.",
        isNetworkError: true,
      });
    }

    if (status === 401 && !isLoggingOut) {
      notify.error(decryptError?.message);

      isLoggingOut = true;

      store.dispatch(authActions.logout());
      const currentPath = window.location.pathname;

      localStorage.removeItem(CONFIG.login_data);
      localStorage.removeItem("auth");
      localStorage.removeItem("hasVisited");

      document.documentElement.classList.remove("dark");

      return;
      if (currentPath.startsWith("/secure")) {
        window.location.href = "/secure/login";
      } else {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
